import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { updateDishTableHotkeys } from '../redux/actions'

const useDishEditableCellHotkey = (dishId, fieldName) => {
  const dispatch = useDispatch()
  const {
    hotkeys: {
      selectedRowKey,
      selectedCellKey,
      isHotkeyEditModeEnabled,
      isDrawerNavigationEnabled,
    },
  } = useSelector(store => store.dishes.dishes)

  const setHotkeyEditModeEnabled = useCallback(
    value =>
      dispatch(updateDishTableHotkeys({ isHotkeyEditModeEnabled: value })),
    [dispatch],
  )

  const setIsDrawerNavigationEnabled = useCallback(
    value =>
      dispatch(updateDishTableHotkeys({ isDrawerNavigationEnabled: value })),
    [dispatch],
  )

  return {
    isDrawerNavigationEnabled,
    isSelectInHotkeyEditMode:
      dishId === selectedRowKey &&
      selectedCellKey === fieldName &&
      isHotkeyEditModeEnabled,
    isFocusOnCell: dishId === selectedRowKey && selectedCellKey === fieldName,
    isFocusOnRow: dishId === selectedRowKey,
    isHotkeyEditModeEnabled,
    setHotkeyEditModeEnabled,
    setIsDrawerNavigationEnabled,
  }
}

export default useDishEditableCellHotkey
